export const travelStyle = "/travel-styles";
export const destinations = "/destinations/region";
export const inspiration = "/travel-inspirations";
export const user = "/user";
export const blog = "/blogs";
export const tripDetail = "/trip-details";

//export const ImageUrl = "https://backend.tripmerchant.ca";

export const WebRoutes = {
  Home: "/",
  TripDetail: `${tripDetail}/:id`,
  TravelStyles: `${travelStyle}/:id`,
  Destinations: `${destinations}/:id`,
  LastMinuteDeals: "/deals",
  ALLCountries: "/countries",
  Tips: `${inspiration}/tips-news`,
  MemberExperience: `${inspiration}/member-experience`,
  videos: `${inspiration}/videos`,
  NewsLetter: "/newsletter-sign-up",
  Search: "/search",
  SoloTravel: "/solo-travel-club",
  LoyaltyProgram: "/loyalty-program",
  OnlinePresentations: "/online-presentation",
  FAQ: "/frequently-asked-question",
  Contest: "/contests",
  pastContest: "/past-contests",
  Privacy: "/privacy-policy",
  Terms: "/terms-and-conditions",
  UserProfile: `${user}/:id`,
  // Blog: `${blog}`,
  BlogbyId: `/blog/:id`,
  WebNotFound: "/not-found",
  groupDepartures: "/group-departures",
  groupDeparturesUpdatedLink:
    "/travel-styles/276f9973-9484-48f8-b273-33dfeed21562",
  testimonials: "/testimonials",
  submitTestimonial: "/submit-testimonial",
  getAllWithFilter: "/trip/getAll-with-filters",
  individual: "/ibe",
  error: "/404-not-found",
  supplierInfo: "/supplier-info",
  tripmerchantJourneys: "/tripmerchant-journeys",
  membersBenefits: "/members-benefits",
  tmUpgrades: "/tm-premium-upgrade",
  reservationForm: `/reservation-form/:id`,
  rewards: "/rewards-program",
  inquire: "/inquire",
};
